// react
import { createSlice } from '@reduxjs/toolkit';
import chatApi from 'store/api/chat';
import { GenerateChatTokenResponse } from '@karehero/models';
import iamApi from 'store/api/iam';

export interface ChatState {
  chatToken: GenerateChatTokenResponse | null;
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    chatToken: null,
  } as ChatState,
  reducers: {
    setChatToken: (state, { payload }) => {
      state.chatToken = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        chatApi.endpoints.generateChatToken.matchFulfilled,
        (state, { payload }) => {
          if (!payload) return;
          state.chatToken = payload;
        },
      )
      .addMatcher(iamApi.endpoints.signOut.matchFulfilled, (state) => {
        state.chatToken = null;
      });
  },
});

export const { setChatToken } = chatSlice.actions;

export const getChatToken = (state: any) => state.chat.chatToken;

export default chatSlice.reducer;
